const reqSvgs = require.context('./assets', true, /\.svg$|.png/);

export default reqSvgs.keys().reduce(
  (a, c) => ({
    ...a,
    [c.replace(/[./]|svg$|png$/gi, '')]: reqSvgs(c),
  }),
  {},
);
